import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";


//查询列表 GET  /client/findPage
export  const findList =(params)=>{
    return http.get('/client/findPage',params)
  }

//新增 /client/insertClient
export function insertClient(params){
    return http.postJSON("/client/insertClient",params);
  }

  //编辑 POST /client/updateClient
  export function updateClient(params){
    return http.postJSON("/client/updateClient",params);
  }

// 删除客户 GET /client/delete
export function deletes({id}){
  return http.get("/client/delete",{id});
}


//厂家 客户级联 GET /user/getCascade
export  const getCascade =({factoryIds})=>{
  return http.get('/user/getCascade',{factoryIds})
}






//中控用户管理列表 post /appUser/findUserInfoPage
export function findUserInfoPage(page,params){
  return http.postJSON("/appUser/findUserInfoPage?"+jsonToFormData(page),params);
}

//查看绑定账户 get /appUser/findUserBindDeviceInfoList
export  const findUserBindDeviceInfoList =({userId})=>{
  return http.get('/appUser/findUserBindDeviceInfoList',{userId})
}





// WEBPACK FOOTER //
// ./src/services/customer.js